/* Suprafeel home: catalogue slider (port of HwfCatalogue.tsx) + smooth scroll for in-page anchors. */
(function () {
  function initSlider(root) {
    if (!root || root.dataset.sfwReady === '1') return;
    var track = root.querySelector('[data-sfw-track]');
    if (!track) return;
    root.dataset.sfwReady = '1';
    var thumb = root.querySelector('[data-sfw-thumb]');
    var prevs = root.querySelectorAll('[data-sfw-prev]');
    var nexts = root.querySelectorAll('[data-sfw-next]');

    function measure() {
      var max = track.scrollWidth - track.clientWidth;
      var size = Math.min(1, track.clientWidth / Math.max(1, track.scrollWidth));
      var p = max > 0 ? track.scrollLeft / max : 0;
      var start = track.scrollLeft <= 2;
      var end = track.scrollLeft >= max - 2;
      if (thumb) {
        thumb.style.left = p * (1 - size) * 100 + '%';
        thumb.style.width = size * 100 + '%';
      }
      prevs.forEach(function (b) { b.disabled = start; });
      nexts.forEach(function (b) { b.disabled = end; });
    }

    function step(dir) {
      var card = track.querySelector('[data-sfw-card]');
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      var w = card ? card.offsetWidth + gap : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }

    prevs.forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
    nexts.forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
    track.addEventListener('scroll', measure, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(track);
    else window.addEventListener('resize', measure);
    measure();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sfw-slider]').forEach(initSlider);
  }

  /* "Ver el catálogo" → #catalogo: smooth scroll (falls back to the native jump). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-sfw-scroll]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var target = document.getElementById(decodeURIComponent(href.slice(1)));
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.pushState) history.pushState(null, '', href);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
